import { render, staticRenderFns } from "./MinTitle.vue?vue&type=template&id=5075f2f5&scoped=true&"
import script from "./MinTitle.vue?vue&type=script&lang=js&"
export * from "./MinTitle.vue?vue&type=script&lang=js&"
import style0 from "./MinTitle.vue?vue&type=style&index=0&id=5075f2f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5075f2f5",
  null
  
)

export default component.exports